import { useAuth } from "../../../contexts/AuthContext";
import "../../../Styles/Layout/MiniDisplays/UserAvatar.css";

export const UserAvatar = () => {
  const { avatar, isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="avatar-wrapper">
      <img src={avatar || ''} alt="User Avatar" />
    </div>
  );
};